<template>
  <HeaderAppDesktop :class="view.headerClass" />
  <HeaderInternal
    :title="doc.title"
    :backLinkDoc="doc"
    class="header--scroll header--book"
    :class="view.headerClass"
  >
    <template v-if="showNewSaveDesign" #actions>
      <DocMoreMenu :doc="doc" />
    </template>
  </HeaderInternal>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'

import type { DocView } from '@/models/doc'
import { HeaderView } from '@/models/header'
import { saveForLater20321Treatment } from '@/services/ab/experiments'

import HeaderAppDesktop from '@/app/components/header/AppDesktop.vue'
import HeaderInternal from '@/app/components/header/Internal.vue'
import DocMoreMenu from '@/app/components/doc/DocMoreMenu.vue'

const props = defineProps<{
  doc: DocView
}>()

const view = ref(new HeaderView(props.doc))

// On mobile, the "more" menu is here instead of the sidebar.
const showNewSaveDesign = saveForLater20321Treatment()

onBeforeMount(async () => {
  await view.value.init()
})
</script>

<style lang="scss" scoped>
/**
 * The class chaining here is necessary to override the specificity from the `HeaderInternal` styles
 */
.header.header--scroll.header--book {
  padding-top: 22px;

  :deep(*) {
    // `.header--scroll` has a fade in animation, but we don't want it
    // on this component
    animation: none;
  }
}
</style>
